export default __webpack_public_path__ + "static/media/certificate.c836f040.jpg";